export default "<p>fmtcharter works!</p>\n"